import React, { FC } from 'react'
import * as ST from './styled'

export interface InputProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  err?: string
  background: string
  onClick?: any
  isActive?: boolean
}

const Button: FC<InputProps> = (props): JSX.Element => {
  return (
    <ST.Button onClick={props.onClick} {...props}>
      {props.children}
    </ST.Button>
  )
}

export default React.memo(Button)
